import React from 'react';
import FeatureCards from "../../../components/FeatureCards/FeatureCards";
import CTA from "../../../components/Constant/cta/CTA";
import TimelineSection from "../../../components/TimelineSection/TimelineSection";
import WhySection from "../../../components/WhySection/WhySection";
import LocationTimeline from "../../../components/LocationTimeline/LocationTimeline";
import IntroSection from "../../../components/IntroSection/IntroSection";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../../components/InfoBlocks/InfoBlocks";
import ServiceCards from "../../../components/ServiceCards/ServiceCards ";

export default function InsuranceReinsuranceLicenseSaintLucia() {

    return (
        <main className='main'>

            <IntroSection
                title="Insurance & Reinsurance License – Saint Lucia"
                subtitle="Establish an Insurance or Reinsurance Company in the Caribbean"
                description="
                <b>Saint Lucia</b> provides a <b>trusted legal framework</b> for <b>insurance and reinsurance companies</b>, regulated by the <b>FSRA (Financial Services Regulatory Authority)</b>.
                <br/>
                The jurisdiction is best known for its <b>captive insurance sector</b>, but also supports <b>general insurance</b> and <b>reinsurance firms</b>, making it an <b>attractive base</b> for <b>regional</b> and <b>international investors</b>.
                "
                badges={
                    [
                        "Captive Insurance",
                        "General Insurance",
                        "Reinsurance Companies"
                    ]
                }
                buttonText="Request a Saint Lucia Insurance Proposal →"
                buttonLink="/quote"
                imageSrc={require("../../../assets/images/services/insurance-reinsurance-license-saint-lucia-hero.png")}
                imageAlt=""
            />

            <section className='section'>
                <div className="container">

                    <WhySection
                        title='Why Choose Saint Lucia for Insurance?'
                        blocks={
                            [
                                {
                                    items:
                                        [
                                            {
                                                title: "Caribbean Hub",
                                                text: "Strong reputation in regional financial services."
                                            },
                                            {
                                                title: "FSRA-Regulated",
                                                text: "Insurance companies licensed under a clear regulatory framework."
                                            },
                                            {
                                                title: "Captive-Friendly",
                                                text: "Flexible structures for multinational corporations."
                                            },
                                            {
                                                title: "Cost-Efficient",
                                                text: "Lower capital requirements compared to EU or US jurisdictions."
                                            },
                                            {
                                                title: "Tax Advantages",
                                                text: "Territorial tax regime with no tax on foreign income."
                                            }
                                        ]
                                }
                            ]
                        }
                    />

                    <InfoBlocks
                        title="Types of Insurance Licenses in Saint Lucia"
                        blocks={[
                            {
                                title: "Captive Insurance License",
                                items: [
                                    { text: "Corporations insure their own risks." },
                                    { text: "Used by multinational groups, shipping, and energy companies." },
                                    { text: "Lower compliance and flexible regulations." }
                                ]
                            },
                            {
                                title: "General Insurance License",
                                items: [
                                    { text: "Covers property, casualty, liability, health, and specialty insurance." },
                                    { text: "Requires higher compliance and solvency monitoring." }
                                ]
                            },
                            {
                                title: "Reinsurance License",
                                items: [
                                    { text: "Operate as regional or global reinsurers." },
                                    { text: "Provide coverage for insurers and other reinsurance companies." },
                                    { text: "Recognized across the Caribbean financial community." }
                                ]
                            }
                        ]}
                    />


                    <LocationTimeline
                        title="Capital & Requirements"
                        item={
                            [
                                {
                                    title: "Captive Insurance",
                                    text: "From USD 100,000."
                                },
                                {
                                    title: "General Insurance",
                                    text: "From USD 150,000–200,000."
                                },
                                {
                                    title: "Reinsurance Companies",
                                    text: "From USD 250,000."
                                },
                                {
                                    title: "Other Requirements",
                                    text: "Local incorporation of a Saint Lucia entity; fit & proper directors and officers; AML/KYC policies in line with FATF standards; annual audits and FSRA compliance reporting."
                                }
                            ]
                        }
                    />

                    <ServiceCards
                        title='Benefits of a Saint Lucia Insurance License'
                        services={
                            [
                                {
                                    title: "Regional Recognition",
                                    text: "Trusted in the Caribbean."
                                },
                                {
                                    title: "Lower Capital Entry",
                                    text: "$100k–$250k compared to millions in EU/US jurisdictions."
                                },
                                {
                                    title: "Flexible Options",
                                    text: "Captives, general insurance, and reinsurance available."
                                },
                                {
                                    title: "Tax Neutrality",
                                    text: "Foreign premiums are not taxed locally."
                                },
                                {
                                    title: "Global Expansion",
                                    text: "Useful as a regional base with international reach."
                                }
                            ]
                        }
                    />

                    <FeatureCards
                        title='Licensing Process'
                        features={
                            [
                                {
                                    title: "Pre-Application Consultation",
                                    text: "Select captive, general, or reinsurance license type."
                                },
                                {
                                    title: "Company Incorporation",
                                    text: "Establish a Saint Lucia International Business Company (IBC)."
                                },
                                {
                                    title: "Application Submission",
                                    text: "Prepare business plan, financials, actuarial support, and AML/KYC documentation."
                                },
                                {
                                    title: "FSRA Review",
                                    text: "Regulator checks solvency, governance, and compliance."
                                },
                                {
                                    title: "Approval & License Issuance",
                                    text: "Typically completed in 6–9 months."
                                }
                            ]
                        }
                    />

                    <TimelineSection
                        title='Timeline & Costs'
                        items={
                            [
                                {
                                    name: "Timeline",
                                    duration: "6–9 months.",
                                },
                                {
                                    name: "Setup Costs",
                                    description: "from USD 60,000+ (legal, actuarial, compliance)."
                                },
                                {
                                    name: "Capital Requirement",
                                    description: "USD 100k–250k."
                                },
                                {
                                    name: "Annual Costs",
                                    description: "regulator supervision, audits, actuarial reporting."
                                },

                            ]
                        }
                    />

                    <DetailsSection
                        title='Why Offshore Advisory?'
                        items={
                            [
                                {
                                    text: "Specialists in Caribbean insurance & reinsurance licensing."
                                },
                                {
                                    text: "End-to-end support: incorporation, licensing, compliance, actuarial reports."
                                },
                                {
                                    text: "Experience with captive structures for multinationals."
                                },
                                {
                                    text: "Comparative insights: St Lucia vs Bermuda vs Cayman vs Panama."
                                },
                                {
                                    text: "Long-term compliance and regulator support."
                                }
                            ]
                        }
                    />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    <CTA
                        title="Looking to establish a captive, insurance, or reinsurance company in the Caribbean?"
                        description="Saint Lucia offers USD 100k–250k entry capital requirements, flexible licensing, and regional recognition."
                        buttonText="Book a Saint Lucia Insurance Consultation →"
                        buttonLink="/quote"
                    />
                </div>
            </section>
        </main>
    );
};
const faqData = [
    {
        question: "What’s the capital requirement for insurance licenses in St Lucia?",
        content: [
            { type: "answer", text: "Captive: USD 100k. General: USD 150k–200k. Reinsurance: USD 250k." },
        ],
    },
    {
        question: "How long does licensing take?",
        content: [
            { type: "answer", text: "Usually 6–9 months." },
        ],
    },
    {
        question: "Is St Lucia good for captives?",
        content: [
            { type: "answer", text: "Yes — it is widely used for multinational captive structures." },
        ],
    },
    {
        question: "Can St Lucia insurers operate internationally?",
        content: [
            { type: "answer", text: "Yes — but strongest recognition is within the Caribbean & LatAm." },
        ],
    },
    {
        question: "Why choose St Lucia over Bermuda or Cayman?",
        content: [
            { type: "answer", text: "Lower costs and lighter regulation, while still credible regionally." },
        ],
    },
];

const testimonialsData = [
    {
        quote: "We established a captive in Saint Lucia. Offshore Advisory handled licensing, actuarial filings, and FSRA relations.",
        author: "James M.",
        role: "Corporate Risk Manager"
    },
    {
        quote: "Saint Lucia gave us a cost-efficient way to launch a regional reinsurance company.",
        author: "Sofia P.",
        role: "Reinsurance Executive"
    }
];
